<template>
  <Toolbar :title="job.Vertragsbeschreibung" :showReload="true" @reload="getJob()" backUrl="/jobs" />

  <div class="w-full text-center">
    <div class="w-full md:w-5/6 inline-block text-left">
  <Spinner v-if="loading" />
  
  <div v-if="job.id" style="padding: 10px">
    <div class="detailline">
      <span class="attributename">Position:</span><span class="attributevalue">{{ job.Pos }}</span>
    </div>
    <div class="detailline">
      <span class="attributename">Funktion:</span><span class="attributevalue">{{ job.Funktion }}</span>
    </div>
    <div class="detailline">
      <span class="attributename">Einsatzort:</span><span class="attributevalue">{{ job.Einsatzort_Beschreibung }}</span>
    </div>
    <div class="detailline">
      <span class="attributename">Einsatzstelle:</span><span class="attributevalue">{{ job.Einsatzstelle_Beschreibung }}</span>
    </div>
    <div class="detailline">
      <span class="attributename">Datum:</span><span class="attributevalue">{{ job.Datum_von }}</span>
    </div>
    <div class="detailline">
      <span class="attributename">Uhrzeit:</span><span class="attributevalue">{{ job.Soll_Von }}-{{ job.Soll_Bis }}</span>
    </div>
    <div class="detailline">
      <span class="attributename">Treffpunkt:</span><span class="attributevalue">{{ job.Treffpunkt }}</span>
    </div>
    <div class="detailline">
      <span class="attributename">Sonstige Infos:</span><span class="attributevalue">{{ job.Bemerkungen }}</span>
    </div>
    <div style="height: 2px; background: black; width: 100%"></div>
    
    <!-- Access Code Section -->
    <div v-if="job.accessCode" class="mt-4">
      <button 
        @click="showAccessCode = !showAccessCode"
        class="w-full bg-blue-600 text-white px-4 py-3 rounded-lg font-bold hover:bg-blue-700 transition-all text-lg"
      >
        <i class="fa fa-key mr-2"></i>{{ showAccessCode ? 'Code verbergen' : 'Registrier-Code anzeigen' }}
      </button>
      
      <div v-if="showAccessCode" class="mt-3 p-4 bg-blue-50 border-2 border-blue-300 rounded-lg">
        <div class="flex items-center justify-between">
          <div>
            <p class="text-sm font-semibold text-blue-800 mb-1">Dein Zugangscode:</p>
            <p class="text-4xl font-mono font-bold text-blue-900">{{ job.accessCode }}</p>
          </div>
          <button 
            @click="copyAccessCode" 
            class="bg-blue-600 text-white px-4 py-2 rounded-lg font-semibold hover:bg-blue-700 transition-all"
            title="Code kopieren"
          >
            <i class="fa fa-copy mr-2"></i>Kopieren
          </button>
        </div>
      </div>
    </div>

    <!-- Parking Ticket Section -->
    <div v-if="job.parkingTicketId" class="mt-4">
      <button 
        @click="viewParkingTicket"
        class="w-full bg-red-600 text-white px-4 py-3 rounded-lg font-bold hover:bg-red-700 transition-all text-lg"
      >
        <i class="fa fa-car mr-2"></i>Parkticket anzeigen
      </button>
    </div>

    <!-- Registration Link Section -->
    <div v-if="job.registrationLink" class="mt-4">
      <div class="bg-blue-50 border border-blue-300 rounded-lg p-4">
        <div class="flex items-center gap-3 mb-2">
          <div class="bg-blue-500 rounded-full p-2">
            <i class="fa fa-link text-white"></i>
          </div>
          <div>
            <p class="font-semibold text-gray-800">Einmalige Registrierung erforderlich</p>
            <p class="text-sm text-gray-600">Registriere dich einmalig für diese Messe/Veranstaltung, falls du das <b>noch nicht</b> getan hast.</p>
          </div>
        </div>
        <a 
          :href="registrationLinkWithAssets" 
          target="_blank"
          class="mt-2 block w-full bg-blue-600 text-white px-4 py-2 rounded-lg font-medium hover:bg-blue-700 transition-all text-center"
        >
          <i class="fa fa-external-link mr-2"></i>Zur Registrierung
        </a>
      </div>
    </div>
    
    <div style="height: 2px; background: black; width: 100%; margin-top: 15px"></div>
    <div style="
        padding: 15px;
        width: 100%;
        display: inline-block;
        text-align: center;
        box-sizing: border-box;
      ">
      <div style="
          padding: 2px;
          margin: 3px;
          font-weight: bold;
          border: 2px solid red;
        " v-if="showError">
        <span>{{ errorMsg }}</span>
      </div>
      <div style="padding: 2px; margin: 3px; font-weight: bold" class="rounded-lg border-4 border-green-500" v-if="showSuccess">
        <span>{{ successMsg }}</span>
      </div>
      <button v-if="job['Zähler_Anzahl'] != 1 && job['Zähler_Anzahl'] != 0" style="width: 100%; border: 2px solid gray; color: gray" disabled>
        Job kann nur in der Hauptansicht angenommen werden
      </button>
      <div v-else>
        <button v-if="showDecline" style="color: red; border: 2px solid red" @click="decline()" class="md:!hidden">
          Absagen
        </button>
        <div class="inline-block md:!hidden" v-if="job.checkinRequired">
          <button id="checkinButton" v-if="!job.checkedIn" @click="checkin()">
            Arbeitsantritt bestätigen
          </button>
        </div>

        <button v-if="showAccept" @click="accept()" class="md:!hidden">Annehmen</button>
        <div v-if="confirmOrDecline" class="md:!hidden">
          <button style="color: red; border: 2px solid red; margin-right: 5px" @click="decline()">
            Absagen
          </button>
          <button :class="{ disabled: confirmDisabled }" style="margin-left: 5px" @click="confirm()">
            Bestätigen
          </button>
        </div>
        <button v-if="job.MA_gebucht && job.current && job.documentsEnabled" @click="window.location='/jobs/'+job.id+'/documents'">Dokumente verwalten</button>
        <button v-if="job.MA_gebucht && job.current && job.routesAvailable" @click="$router.push({name: 'EWKSList', params: { jobid: job.id }})">Rundgänge</button>
      </div>
    </div>
  </div>
  <div v-else-if="!loading" style="width: 100%; text-align: center; padding: 20px; padding-top: 100px">
    <span style="font-size: 25px; font-weight: bold">Dieser Job ist bereits vergeben oder wurde gelöscht.</span>
  </div></div></div>
</template>

<script>
  import CASP from "../../CASP";
  import Spinner from "@/components/Spinner";
  import Toolbar from "@/components/Toolbar";
  import { useCookies } from "vue3-cookies";
  export default {
    setup() {
      const { cookies } = useCookies();
      return { cookies };
    },
    name: "Jobdetails",
    components: {
      Toolbar,
      Spinner,
    },
    data() {
      return {
        window: window,
        loading: true,
        showAccept: false,
        confirmOrDecline: false,
        showDecline: false,
        showPrivate: true,
        showPublic: false,
        confirmDisabled: false,
        showError: false,
        showSuccess: false,
        errorMsg: "",
        successMsg: "",
        job: [],
        allJobs: [],
        showReload:true,
        showAccessCode: false,
      };
    },
    computed: {
      registrationLinkWithAssets() {
        if (!this.job.registrationLink) return '';
        const url = new URL(this.job.registrationLink);
        url.searchParams.set('assets', '1');
        return url.toString();
      }
    },
    methods: {
      getJob() {
        const comp = this;
        this.showAccept = false;
        this.showDecline = false;
        this.confirmOrDecline = false;
        CASP.getJobById(this.token, this.$route.params.jobid, (job) => {
          if(!job){
            if(localStorage && localStorage.getItem("stats")){
              let stats=JSON.parse(localStorage.getItem("stats"))
              if(stats.currentJob && stats.currentJob.id == this.$route.params.jobid){
                job = stats.currentJob
              }
            }
          }
          if(!job) return
          comp.job = job;
          comp.loading = false;
          if (job.id !== undefined) {
            const dp = job.Datum_von.split(".");
            let startTime = new Date(
              dp[2] + "-" + dp[1] + "-" + dp[0] + "T" + job.Soll_Von + ":00Z"
            );
            startTime = new Date(
              startTime.getTime() + startTime.getTimezoneOffset() * 60000
            );
            const now = new Date();
            if (now.getTime() < startTime.getTime()) {
              if (!job.MA_gebucht) {
                comp.showAccept = true;
              } else if (!job["MA_bestätigt"]) {
                comp.confirmOrDecline = true;
                if (startTime.getTime() - now.getTime() > 30 * 60 * 60 * 1000) {
                  comp.confirmDisabled = true;
                }
              }
            }
            if (job.checkedIn) {
              this.showSuccessMessage(
                "Du hast dich um " + job.checkedIn + " angemeldet."
              );
            }
          }
        });
      },
      copyAccessCode() {
        if (navigator.clipboard && this.job.accessCode) {
          navigator.clipboard.writeText(this.job.accessCode).then(() => {
            this.showSuccessMessage('Code kopiert: ' + this.job.accessCode);
          }).catch(() => {
            this.showErrorMessage('Fehler beim Kopieren des Codes');
          });
        }
      },
      viewParkingTicket() {
        if (!this.job.parkingTicketId) return;
        
        // First get the parking ticket to get the fileId
        CASP.getParkingTicket(this.job.parkingTicketId, (status, ticket) => {
          if (status === 200 && ticket && ticket.fileId) {
            // Use OTL mechanism to securely view the file
            CASP.getFileOTL(ticket.fileId, (otlStatus, response) => {
              if (otlStatus === 200 && response.link) {
                window.location = process.env.VUE_APP_API_URL + response.link;
              } else {
                this.showErrorMessage('Fehler beim Laden der Parkticket-Datei');
              }
            });
          } else {
            this.showErrorMessage('Fehler beim Laden des Parktickets');
          }
        });
      },
      back() {
        if (
          this.job["Zähler_Anzahl"] &&
          this.job["Zähler_Anzahl"] != 1 &&
          this.job["Zähler_Anzahl"] != 0
        ) {
          window.location = "/group/" + this.job["Zähler_Anzahl"];
        } else {
          window.location = "/jobs";
        }
      },
      showErrorMessage(message) {
        this.showError = true;
        this.showSuccess = false;
        this.errorMsg = message;
        const comp = this;
        setTimeout(() => {
          comp.showError = false;
        }, 5000);
      },
      showSuccessMessage(message) {
        this.showError = false;
        this.showSuccess = true;
        this.successMsg = message;
      },
      accept() {
        const comp = this;
        CASP.acceptJob(
          this.token,
          this.$route.params.jobid,
          (scode, response) => {
            if (scode === 200) {
              comp.showSuccessMessage("Du hast diesen Auftrag angenommen");
              if (response && response.id && response.id !== comp.$route.params.jobid) {
                comp.$router.replace({ name: "Jobdetails", params: { jobid: response.id } }).then(() => comp.getJob());
              } else {
                comp.getJob();
              }
            } else {
              this.showErrorMessage(response);
            }
          }
        );
      },
      checkin() {
        const comp = this;
        CASP.checkInJob(this.token, this.$route.params.jobid, (response) => {
          if (response && response.status == "success") {
            comp.showSuccessMessage(
              "Du hast dich um " + response.time + " angemeldet"
            );
            comp.getJob();
          } else {
            this.showErrorMessage(response.error);
          }
        });
      },
      decline() {
        const comp = this;
        CASP.declineJob(
          this.token,
          this.$route.params.jobid,
          (scode, response) => {
            if (scode === 200) {
              comp.showSuccessMessage("Du hast diesen Auftrag abgesagt");
              comp.getJob();
            } else {
              this.showErrorMessage(response);
            }
          }
        );
      },
      confirm() {
        if (this.confirmDisabled) {
          this.showErrorMessage(
            "Du kannst diesen Auftrag erst 30 Stunden vor Beginn bestätigen"
          );
        } else {
          const comp = this;
          CASP.confirmJob(
            this.token,
            this.$route.params.jobid,
            (scode, response) => {
              if (scode === 200) {
                comp.showSuccessMessage("Du hast diesen Auftrag bestätigt");
                comp.getJob();
              } else {
                this.showErrorMessage(response);
              }
            }
          );
        }
      },
    },
    created: function () {
      document.getElementById("mainspinner").style.display = "none";
      if (this.cookies.get("caspauth") || this.cookies.get("authtoken")) {
        this.token = this.cookies.get("caspauth") || this.cookies.get("authtoken");
        this.getJob();
      } else {
        window.location = "/forbidden";
      }
    },
  };
</script>
<style scoped>
  .detailline {
    margin-top: 15px;
    margin-bottom: 15px;
    display: flex;
  }

  .attributename {
    display: inline-block;
    flex-grow: 1;
    flex-basis: 33.33%;
    font-weight: bold;
  }

  .attributevalue {
    border-bottom: 1px solid black;
    flex-grow: 2;
    flex-basis: 66.66%;
  }

  /* Style the buttons that are used to open the tab content */
  button {
    cursor: pointer;
    padding: 10px 14px;
    display: inline-block;
    color: rgb(52, 199, 89);
    border: 2px solid rgb(52, 199, 89);
    border-radius: 8px;
    font-weight: bold;
    font-size: 18px;
    width: 40%;
    background-color: white;
  }

  #checkinButton {
    width: auto;
    border-width: 4px;
  }

  .disabled {
    border: 1px solid gray;
    color: gray;
  }
</style>